import React from 'react';
import {
  Route,
  Redirect,
} from 'react-router';
import WithServicesUrlPattern from '../hoc/WithServicesUrlPattern';
import ShopMainLayout from '../components/ShopMainLayout';
import Services from './services/ServicesContainer';
import Barbers from './services/Barber';
import MakeReservation from '../reservation/MakeReservation';
import { getServiceUrls } from '../utils/helpers';


export default (urlPattern) => {
  const urls = getServiceUrls(urlPattern);

  // Put component in variable to prevent rerendering
  const ServiceBarbers = WithServicesUrlPattern(Barbers);

  return (
    <Route component={WithServicesUrlPattern(ShopMainLayout)}>
      <Route
        path={urls.services}
        component={WithServicesUrlPattern(Services)}
      />
      <Route
        path={urls.barbers}
        component={ServiceBarbers}
        ignoreScrollBehavior
      />
      <Route
        path={urls.pickTime}
        component={ServiceBarbers}
        ignoreScrollBehavior
      />
      <Route
        path={urls.makeReservation}
        component={WithServicesUrlPattern(MakeReservation)}
      />
      <Redirect
        from={`${urls.makeReservation}/**`}
        to={urls.makeReservation}
      />
    </Route>
  );
};




// WEBPACK FOOTER //
// ./src/app/dynamicBooking/ServicesRoutes.jsx